module.exports = __webpack_public_path__ + "static/media/mobileBackground.8b267c23.jpg";